// components/services/scoringServices.js
import api from './api';

export const getScoringSummary = async (params = {}) => {
  // Mapping param frontend -> backend
  let queryParams = {
    page: params.page || 1,
    limit: params.limit || 10,          // default limit 10 per page
    search: params.search || '',
    district_id: params.district || '',
    sub_district_id: params.subdistrict || '',
    sort_by: params.sortBy || 'id',     // default urut berdasarkan id
    sort_order: params.sortOrder || 'asc' // asc / desc
  };

  // Hapus key kosong/null/undefined
  Object.keys(queryParams).forEach((key) => {
    if (
      queryParams[key] === '' ||
      queryParams[key] === null ||
      queryParams[key] === undefined
    ) {
      delete queryParams[key];
    }
  });

  // Request ke API
  const response = await api.get('/scoring/summary', { params: queryParams });

  // DEBUG LOG
  // console.log('>>> scoringService Request params:', queryParams);
  // console.log('>>> scoringService Response:', response.data);

  return response.data;
};

export const getScoringData = async (params = {}) => {
  // Mapping param frontend -> backend
  let queryParams = {
    page: params.page || 1,
    limit: params.limit || 10,          // default limit 10 per page
    search: params.search || '',
    district_id: params.district || '',
    sub_district_id: params.subdistrict || '',
    sort_by: params.sortBy || 'id',     // default urut berdasarkan id
    sort_order: params.sortOrder || 'asc' // asc / desc
  };

  // Hapus key kosong/null/undefined
  Object.keys(queryParams).forEach((key) => {
    if (
      queryParams[key] === '' ||
      queryParams[key] === null ||
      queryParams[key] === undefined
    ) {
      delete queryParams[key];
    }
  });

  // Request ke API
  const response = await api.get('/scoring', { params: queryParams });

  // DEBUG LOG
  // console.log('>>> scoringService Request params:', queryParams);
  // console.log('>>> scoringService Response:', response.data);

  return response.data;
};

export const getScoringDataById = async (id) => {
  const response = await api.get(`/scoring/${id}`);
  return response.data;
};

export const createScoringData = async (formData) => {
  // console.log('formData:', formData);
  // for (let [key, value] of formData.entries()) {
  //   // console.log(`formData ${key}:`, value);
  // }
  const response = await api.post('/scoring', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateScoringData = async (id, formData) => {
  const response = await api.put(`/scoring/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteScoringData = async (id) => {
  const response = await api.delete(`/scoring/${id}`);
  return response.data;
}; 

export const calculateScoring = async () => {
  const response = await api.get("/scoring/calculate");
  return response.data;
};

